import { Building } from 'store/building/types';
import { createAsyncAction } from 'typesafe-actions';

export const getBuilding = createAsyncAction('GET_BUILDING_REQUEST', 'GET_BUILDING_SUCCESS', 'GET_BUILDING_FAILURE')<
  string,
  Building,
  Error
>();
